<template>
    <div class="page">

<!--如果添加或减少tab，删除HTML结构后需要在lastStep和nextStep方法中添加或移除相应的查询条件，并且修改俩个切换按钮的禁用规则disabled-->

        <el-form ref="form" :model="attributeWholeList" style="height: 100%;">
            <el-tabs tab-position="left" style="height: 90%;overflow: auto" v-model='tabs'>
                <el-tab-pane name="first" style="padding-left: 30px" label="基本信息">
                    <information-add ref="form1"></information-add>
                </el-tab-pane>
                <el-tab-pane name="second" style="padding-left: 30px" label="商品相册">
                    <el-form-item label="商品相册" prop="productAlbum">
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过{{ fileSize }}MB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品视频" prop="productAlbum">
                        <el-upload
                            class="uploadAlbum"
                            action=""
                            :file-list="videoFileList"
                            :before-upload="handleBeforeUpload"
                            :on-remove="handleVodRemove"
                            :http-request="uploadAvatar"
                            :on-success="onSucc"
                            list-type="picture"
                            :limit="1"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过100mb</div>
                        </el-upload>
                        <!-- <el-upload
                            class="upload-demo"
                            drag
                            action=""
                            multiple
                            :limit="3"
                            :file-list="videoFileList"
                            :before-upload="handleBeforeUpload"
                            :on-remove="handleVodRemove"
                            :http-request="uploadAvatar"
                            :on-success="onSucc"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传mp4文件，且不超过50mb</div>
                        </el-upload> -->
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="thirdly" style="padding-left: 30px" label="商品描述">
                    <el-form-item label="" prop="saleStatement">
                        <el-input
                            placeholder="请输入简介"
                            type="textarea"
                            style="width: 820px"
                            size="small"
                            :rows="3"
                            v-model="attributeWholeList.saleStatement"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="productContent">
                        <WangEditor ref="contentEditor" v-model="attributeWholeList.productContent" />
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="fourthly" style="padding-left: 30px" label="商品属性">
                    <spu-add ref="form2"></spu-add>
                </el-tab-pane>
                <el-tab-pane name="fifth" style="padding-left: 30px" label="商品规格">
                    <sku-add ref="form3"></sku-add>
                </el-tab-pane>
            </el-tabs>
            <div class="bottm-btn">
                <el-button style="margin-left: 30px" type="primary" :disabled='tabs=="first"' @click="lastStep">上一步</el-button>
                <el-button style="margin-left: 30px" type="primary" :disabled='tabs=="fifth"' @click="nextStep">下一步</el-button>

                <!--点击确认添加基本信息没用填写完整时，需要不tabs的值改为没用填完整那个tab的name-->

                <el-button style="margin-left: 30px" type="primary" @click="submitForm">确认添加</el-button>
                <el-button style="margin-left: 30px" type="danger" @click="$refs.ImportProduct.show();">采集商品信息</el-button>
            </div>
        </el-form>
        <import-product ref="ImportProduct" @getProductDetails="getProductDetails"></import-product>
    </div>
</template>

<script>
import InformationAdd from '../../components/shop/InformationAdd.vue';
import spuAdd from '../../components/shop/spuAdd.vue';
import skuAdd from '../../components/shop/skuAdd.vue';
import ImportProduct from '@/components/shop/ImportProduct.vue';
import WangEditor from '@/components/common/wangeditor';
import { get, post, postJson, upload } from '@/utils/request.js';
import { UPLOAD_PATH,UPLOAD_API } from '@/utils/constant.js';

export default {
    components: {
        InformationAdd,
        spuAdd,
        skuAdd,
        ImportProduct,
        WangEditor,
    },
    data() {
        return {
            tabs:'first',
            attributeWholeList: {
                productContent: '',
                saleStatement: '',
                productAlbum: '',
                productVideo: '',
            },
            albumList: '',
            isScoreList: [
                {
                    value: 0,
                    label: '否'
                },
                {
                    value: 1,
                    label: '是'
                }
            ],
            header: {
                token: localStorage.getItem('token')
            },
            fileList: [],
            videoFileList: [],
            temporaryList: [],
            action: UPLOAD_API + UPLOAD_PATH,
            fileType: ['mp4'],
            // 上传文件大小限制(MB)
            fileSize: '100'
        };
    },
    mounted() {},
    watch: {
        'attributeWholeList.productVideo': {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        //上一步
        lastStep(){
            switch (this.tabs) {
                case 'second': this.tabs = 'first';
                    break;
                case 'thirdly': this.tabs = 'second';
                    break;
                case 'fourthly': this.tabs = 'thirdly';
                    break;
                case 'fifth': this.tabs = 'fourthly';
                    break;
            }
        },
        //下一步
        nextStep(){
            switch (this.tabs) {
                case 'first': this.tabs = 'second';
                    break;
                case 'second': this.tabs = 'thirdly';
                    break;
                case 'thirdly': this.tabs = 'fourthly';
                    break;
                case 'fourthly': this.tabs = 'fifth';
                    break;
            }
        },
        handleRemove(file, fileList) {
            console.log(file);
            console.log(fileList);
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (file.response.url == this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.albumList = this.temporaryList.join('|');

            console.log(this.temporaryList);
        },
        //上传成功
        handleSuccess(response, file, fileList) {
            console.log(response);
            console.log(file);
            console.log(fileList);
            this.temporaryList.push(file.response.url);
            console.log(this.temporaryList);
            this.albumList = this.temporaryList.join('|');
            console.log(this.albumList);
        },
        // 上传失败
        handleError(error, file, fileList) {
             this.$message({
                message: '上传失败',
                type: 'error',
                duration: 2000
            });
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
         submitForm() {
            // console.log(this.$refs.contentEditor.init(this.attributeWholeList.productContent));
            // return;
            if (!this.$refs.form1.validateForm()) {
                this.tabs = 'first'
                this.$message({
                    message: '基本信息页没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            if (!this.$refs.form2.validateForm()) {
                this.$message({
                    message: '商品属性没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            let spuList = [];
            let spuValueList = [];
            let skuList = [];
            let skuValueList = [];
            let attributeList = this.$refs.form2.attributeForm.attributeList;
            let tableData = this.$refs.form3.tableData;
            let product = this.$refs.form1.shopProduct;
            let supplyChainProduct = this.$refs.form1.selectDialogData
            let temporskuList = this.$refs.form3.skuList;

            for (let item of temporskuList) {
                if(item.valueKv.length == 0){
                    continue
                }
                let obj = {
                    nameKvId: item.nameKvId,
                    valueKvIds: ''
                };

                for (let element of item.valueKv) {
                    obj.valueKvIds += element.kvId + ',';
                }
                if (obj.valueKvIds.length > 0) {
                    obj.valueKvIds = obj.valueKvIds.substr(0, obj.valueKvIds.length - 1);
                }
                skuList.push(obj);
            }

            for (let item of attributeList) {
                if (item.disabled == 1) {
                    // let id = this.guid();
                    // let reg = new RegExp('-', 'g');
                    // id = id.replace(reg, '');
                    //console.log('22222222222222222222222222222',item)
                    spuList.push({
                        isRequired: item.isRequired,
                        nameKvId: item.nameKvId,
                        valueKvIds: item.valueKvIds,
                        valueType: item.valueType,
                        spuValue: {
                            value: item.valueType == 1 ? item.kvName : item.valueKvList
                        }
                    });
                    // spuValueList.push({
                    //     spuId: id,
                    //     value: item.valueType == 1 ? item.kvName : item.valueKvList
                    // });
                }
                // else {
                //     skuList.push({
                //         nameKvId: item.nameKvId,
                //         valueKvIds: item.valueKvIds
                //     });
                // }
            }
            const numRatio = (v) => {
                const n = Number(v);
                return Number.isFinite(n) ? n : 0;
            };
            for (let item of tableData) {
                skuValueList.push({
                    skuKvIds: item.skuKvIds,
                    price: item.price,
                    stock: item.stock,
                    pic: item.pic,
                    supplyPrice: item.supplyPrice,
                    vbaoEnterRatio: numRatio(item.vbaoEnterRatio)
                });
            }

            console.log("你要提交喽")
            console.log(spuList);
            console.log(spuValueList);
            console.log(skuList);
            console.log(skuValueList);

            this.attributeWholeList.productAlbum = this.albumList;
            let shopProduct = {
                ...product,
                ...this.attributeWholeList,
                spuList: spuList,
                skuList: skuList,
                skuValueList: skuValueList
            };

            if (
                shopProduct.vbaoEnterRatio !== undefined &&
                shopProduct.vbaoEnterRatio !== null &&
                shopProduct.vbaoEnterRatio !== ''
            ) {
                shopProduct.vbaoEnterRatio = numRatio(shopProduct.vbaoEnterRatio);
            }

            if(shopProduct.isSupplyChain === 1) {
                shopProduct.supplyProductId = supplyChainProduct.proId
                shopProduct.supplyProductCode = supplyChainProduct.proNo
                shopProduct.supplySkuCode = supplyChainProduct.row.skuNo
            } else {
                shopProduct.supplyProductId = ""
                shopProduct.supplyProductCode = ""
                shopProduct.supplySkuCode = ""
            }

            delete shopProduct.isSupplyChain
            delete shopProduct.supplyChainProduct

            console.log('shopProduct', shopProduct, supplyChainProduct);
            
            postJson('/shop/product/add', { ...shopProduct }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.$router.push('/shop/ProductList');
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        // 生成唯一Id
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        //上传视频
        uploadAvatar(params) {
            const file = params.file;
            console.log(file);
            // let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            // if (!types.includes(file.type)) {
            //     this.$message.error('图片类型错误!');
            // }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.attributeWholeList.productVideo = res.url;
                    console.log(this.attributeWholeList.productVideo);
                }
            });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            console.log(this.attributeWholeList.productVideo);
            if (this.attributeWholeList.productVideo != '') {
                this.$message({
                    message: '最多上传一个视频',
                    type: 'info',
                    duration: 2000
                });
                return false;
            }
            // 校检文件类型
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk && file) {
                    this.$message({
                        message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            // 校检文件大小;
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message({
                        message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }

            return true;
        },
        handleVodRemove(file, fileList) {
            // console.log(file);
            // console.log(fileList);
            if (fileList.length == 0) {
                this.attributeWholeList.productVideo = '';
            }
        },
        onSucc(response, file, fileList) {
            console.log(this.videoFileList);
        },

        // 从第三方获取商品详情
        getProductDetails(value){
            // 写入商品名称和主图
            this.$refs.form1.settingGrabInfo(value)
            let productDetails = value.productDetails.map((item)=>{
                return "<img src=\""+ item +"\">"
            }).join("")

            // 写入商品相册
            // {name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
            this.fileList = value.productAlbum.map((item)=>{
                return {
                    name: item,
                    url: item
                }
            });
            this.temporaryList = value.productAlbum;
            this.albumList = this.temporaryList.join('|');

            // 写入商品详情
            this.$refs.contentEditor.init(productDetails);

        },
    }
};
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 30px;
}
.bottm-btn{
    margin-top: 20px;
    padding-left: 100px;
}
// ::v-deep .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     width: 200px;
//     height: 200px;
// }
</style>
